module.exports = __webpack_public_path__ + "img/status-icn_draft@3x.31b0a5d8.png";